import React from "react";
import CustomTextarea from "../../../../../../../Components/CustomInputs/CustomTextarea";
import { useDispatch, useSelector } from "react-redux";
import { StoreType } from "../../../../../../../redux/store/store";
import { updateFirstStepDynamicFields } from "../../../../../../../redux/reducers/claimReducer";
import { handleShowErrorMessage } from "../../../../../../../redux/reducers/claimFieldErrorsReducer";
import WholeLineContainer from "../../../../../../../Components/ReportFormTemplate/WholeLineContainer";
import { shouldRenderSpecField } from "../../../../../../../redux/reducers/visibilityMatrixesReducer";
import getValuesForFirstStepGeneralFields from "../../../../../../../Utils/ClaimModelUpdateFunctions/GetValuesForFirstStepGeneralFields";
import { useScrollToTopErrorInput } from "../../../../../../../CustomHooks/useScrollToTopErrorInput";

const WorkIncapacityAdditionalInjuryDescriptionField: React.FC = () => {
   const dispatch = useDispatch();

   const AdditionalInjuryDescriptionValueWorkIncapacity = useSelector(
      (state: StoreType) =>
         state.claimState.injuryDescriptionModelBase.injuryDescriptionModel.find(
            (model) => model.typeOfClaimEnum === 2
         )?.additionalInjuryDescription
   );

   const visibilityMatrixes = useSelector(
      (state: StoreType) => state.visibilityMatrixesState
   );

   const claimFieldErrorsMessages = useSelector(
      (state: StoreType) => state.claimFieldErrorsState
   );
   const ref = React.useRef<HTMLDivElement>(null);
   useScrollToTopErrorInput(ref, "incapacity.AdditionalInjuryDescription");
   return (
      <WholeLineContainer
         dependencyValue={shouldRenderSpecField(
            "incapacity",
            "AdditionalInjuryDescription",
            visibilityMatrixes
         )}
      >
         <CustomTextarea
            labelText="Popište podrobně, co se stalo"
            placeholderText="Popište co nejpodrobněji"
            name="AdditionalInjuryDescription"
            value={AdditionalInjuryDescriptionValueWorkIncapacity || ""}
            onChange={(e) => {
               dispatch(
                  updateFirstStepDynamicFields({
                     value: e.target.value.slice(0, 240),
                     field: "additionalInjuryDescription",
                     typeOfClaimEnum: 2,
                  })
               );
            }}
            validationText={handleShowErrorMessage(
               "incapacity.AdditionalInjuryDescription",
               claimFieldErrorsMessages
            )}
            inputRef={ref}
            maxCharacters="240"
            highlightMaxCharacters={
               AdditionalInjuryDescriptionValueWorkIncapacity?.length === 240
            }
         />
      </WholeLineContainer>
   );
};

export default WorkIncapacityAdditionalInjuryDescriptionField;
